export default "__VITE_ASSET__BPX_HEPd__"